export default "__VITE_ASSET__a855887e__"